import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import { getProducts, getProductById } from "../services/product.service";
import ProductCard from "./ProductCard";

const NewArrivalTwo = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchRelatedProducts = async () => {
            setLoading(true);
            try {
                const queryParams = new URLSearchParams(location.search);
                const currentProductId = queryParams.get("id");
                
                let relatedProducts = [];
                
                if (currentProductId) {
                    const currentProduct = await getProductById(currentProductId);
                    if (currentProduct && currentProduct.categoryId) {
                        // Fetch products from the same category
                        const categoryProducts = await getProducts(currentProduct.categoryId);
                        // Filter out the current product
                        relatedProducts = categoryProducts.filter(p => p.id !== currentProductId);
                    }
                }
                
                // If no related products in category, fallback to latest products
                if (relatedProducts.length === 0) {
                    const allProducts = await getProducts();
                    relatedProducts = allProducts.filter(p => p.id !== currentProductId).slice(0, 10);
                }
                
                setProducts(relatedProducts);
            } catch (error) {
                console.error("Error fetching related products:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchRelatedProducts();
    }, [location.search]);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: products.length > 4,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    if (loading) return null;
    if (products.length === 0) return null;

    return (
        <section className="new-arrival pb-80">
            <div className="container container-lg">
                <div className="section-heading mb-24">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="ms-30 mb-0 text-uppercase">You Might Also Like</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-bold text-main-600 hover-text-main-700"
                            >
                                View All Products
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="new-arrival__slider arrow-style-two">
                    <Slider {...settings}>
                        {products.map((product) => (
                            <div key={product.id} className="px-8">
                                <ProductCard product={product} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default NewArrivalTwo